/**
 * A mask that fades out whichever edge of a scroller has content clipped past
 * it (pair with `useScrollEdges`): left/right, or top/bottom with `axis: 'y'`.
 * Undefined when nothing is clipped.
 */
export function edgeMask(start: boolean, end: boolean, fade = '24px', axis: 'x' | 'y' = 'x'): string | undefined {
  if (!start && !end) return undefined
  const from = start ? `transparent, black ${fade}` : 'black'
  const to = end ? `black calc(100% - ${fade}), transparent` : 'black'
  return `linear-gradient(${axis === 'x' ? 'to right' : 'to bottom'}, ${from}, ${to})`
}
